import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";
import logo from "@/assets/logo.png";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.forgot(email.trim());
      setSent(true);
    } catch (err) {
      toast.error(err.message || "Gagal mengirim tautan reset");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto min-h-screen w-full max-w-md lg:max-w-lg bg-white px-6 pt-6" data-testid="forgot-page">
      <header className="mb-8 flex items-center gap-3">
        <button onClick={() => navigate("/login")} className="text-zinc-500" data-testid="forgot-back">
          <ArrowLeft className="h-5 w-5" />
        </button>
        <img src={logo} alt="CeKKeU" data-testid="auth-logo" className="h-14 w-auto" />
      </header>

      {sent ? (
        <div className="rounded-3xl border border-zinc-200 bg-white p-6 shield-shadow" data-testid="forgot-sent">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-50">
            <MailCheck className="h-5 w-5 text-emerald-600" />
          </div>
          <h1 className="mt-4 font-heading text-2xl font-extrabold text-zinc-900">Cek email Anda</h1>
          <p className="mt-2 text-sm text-zinc-500">
            Jika email tersebut terdaftar, kami telah mengirim tautan untuk mengatur ulang password.
            Tautan berlaku selama 1 jam.
          </p>
          <div className="mt-3 rounded-xl bg-zinc-50 p-3 text-xs text-zinc-600">
            💡 <b>Tips:</b> Jika tidak ada di kotak masuk, periksa juga folder <b>Spam</b>, <b>Bulk</b>, atau <b>Promosi</b> di email Anda.
          </div>
          <Button
            onClick={() => navigate("/login")}
            className="mt-6 h-12 w-full rounded-full bg-zinc-900 text-sm font-semibold hover:bg-zinc-800"
          >
            Kembali ke Masuk
          </Button>
        </div>
      ) : (
        <>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-zinc-900">Lupa password</h1>
          <p className="mt-2 text-sm text-zinc-500">
            Masukkan email akun Anda. Kami akan mengirimkan tautan untuk mengatur ulang password.
          </p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label className="text-sm font-medium text-zinc-700 font-heading">Email</Label>
              <Input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@email.com"
                className="h-12 rounded-2xl border-zinc-200 text-base"
              />
            </div>
            <Button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={busy}
              className="h-14 w-full rounded-full bg-zinc-900 text-base font-semibold hover:bg-zinc-800"
            >
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Kirim tautan reset"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-zinc-500">
            Ingat password Anda?{" "}
            <Link to="/login" className="font-semibold text-emerald-600">
              Masuk
            </Link>
          </p>
        </>
      )}
    </div>
  );
}
